import React from 'react';
import SKURow from './SKURow';

const ProductRow = ({
  product,
  locationsBySelectedRegion,
  expandedProducts,
  toggleProductExpansion,
  findSKUStatus,
  tableData,
  expandedRegions,
  pendingData,
  pendingDataUS,
  pendingDataUK,
  getLocationDisplayName,
}) => {
  const isExpanded = expandedProducts.includes(product.productName);

  return (
    <React.Fragment>
      <tr
        className="border-b hover:bg-blue-50 cursor-pointer"
        onClick={() => toggleProductExpansion(product.productName)}>
        <td className="px-3 py-3 sticky left-0 bg-white border-r min-w-[200px] max-w-[250px]">
          <div className="flex items-center gap-2">
            <span className="font-medium truncate" title={product.productName}>
              {product.productName}
            </span>
          </div>
        </td>
        {Object.entries(locationsBySelectedRegion).map(([region, locations]) => (
          <React.Fragment key={region}>
            <td className="px-3 py-3 text-center font-medium border-r">
              {/* Placeholder for product region total */}
            </td>
            {expandedRegions[region] && (
              <>
                <td className="px-3 py-3 text-center border-r">
                  {/* Status for product level - placeholder */}
                </td>
                <td className="px-3 py-3 text-center border-r">
                  {/* Container for product level - placeholder */}
                </td>
                <td className="px-3 py-3 text-center border-r">
                  {/* Pending for product level - placeholder */}
                </td>
                {locations.map((location) => (
                  <td key={location} className="px-3 py-3 text-center border-r"></td>
                ))}
              </>
            )}
          </React.Fragment>
        ))}
      </tr>
      {isExpanded &&
        product.variants.map((variant, index) => (
          <SKURow
            key={`${variant.sku}-${index}`}
            variant={variant}
            locationsBySelectedRegion={locationsBySelectedRegion}
            findSKUStatus={findSKUStatus}
            tableData={tableData}
            expandedRegions={expandedRegions}
            pendingData={pendingData}
            pendingDataUS={pendingDataUS}
            pendingDataUK={pendingDataUK}
            getLocationDisplayName={getLocationDisplayName}
          />
        ))}
    </React.Fragment>
  );
};

export default React.memo(ProductRow);
